// extracted by mini-css-extract-plugin
module.exports = {"selectedServiceDomain":"ServiceDomain_selectedServiceDomain__3_uYg","deleteServiceDomainContainer":"ServiceDomain_deleteServiceDomainContainer__T1Gx2"};